/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Infolink1Inputs */

const en__field_infolink1 = /** @type {(inputs: _Field_Infolink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link for additional information`)
};

const de__field_infolink1 = /** @type {(inputs: _Field_Infolink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link mit weiterführenden Informationen`)
};

/**
* | output |
* | --- |
* | "Link for additional information" |
*
* @param {_Field_Infolink1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_infolink1 = /** @type {((inputs?: _Field_Infolink1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Infolink1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_infolink1(inputs)
	return de__field_infolink1(inputs)
});
export { _field_infolink1 as "_field_infoLink" }